// removed by extract-text-webpack-plugin
module.exports = {"cols":"src-containers-Product----Product-module---cols---3VT7U","imageWrapper":"src-containers-Product----Product-module---imageWrapper---3hqDh","descriptionWrapper":"src-containers-Product----Product-module---descriptionWrapper---1lt9B","variants-dropdown":"src-containers-Product----Product-module---variants-dropdown---2OJwR","description":"src-containers-Product----Product-module---description---3ltvI","product-code":"src-containers-Product----Product-module---product-code---3vTGd","heading":"src-containers-Product----Product-module---heading---J8bjH"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Product/Product.module.scss
// module id = 1219
// module chunks = 137591856104208